import jqRequest from '../jqRequest'
import mediaUrls from '../urls/media'

export default {
  // 自媒体号详细信息
  getSelfMediaById(data) {
    return jqRequest.requestWithToken(mediaUrls.getSelfMediaFreChannel, data);
  },
  // 媒体号文章分类下的文章列表
  findContentPageByFreChannelId(data) {
    return jqRequest.requestWithToken(mediaUrls.findContentPageByFreChannelId, data);
  },
  // 查询是否订阅
  isSubscribe(data) {
    return jqRequest.requestWithToken(mediaUrls.isSubscribe, data);
  },
  // 订阅
  subscribeSelfMedia(data) {
    return jqRequest.requestWithToken(mediaUrls.subscribeSelfMedia, data);
  },
  // 取消订阅
  unSubscribeSelfMedia(data) {
    return jqRequest.requestWithToken(mediaUrls.unSubscribeSelfMedia, data);
  },
  // 留言
  listSelfMediaMessages(data) {
    return jqRequest.requestWithToken(mediaUrls.listSelfMediaMessages, data, 'get');
  },
  // 新增留言
  addSelfMediaMessages(data) {
    return jqRequest.requestWithToken(mediaUrls.addSelfMediaMessages, data);
  },
  // 删除自己留言
  deleteSelfMediaMessages(data) {
    return jqRequest.requestWithToken(mediaUrls.deleteSelfMediaMessages, data);
  },
}